import React, { useEffect, useState } from 'react'
import { Icon, Modal, Select, InputNumber, message, Button, Upload, Input, Collapse, Spin, Popover, Tooltip } from 'antd'
import { createFileListFromServer, createImageListFromServer, buildEmptyListColor, normalizeServerFiles, extractUrlsAndNamesFromUI, mergeFinalFilesForField, countEmbroideryLocations } from '../../helper/ItemImageHelper'
import { parseJwt } from "../../../../helpers/parseToken"
import { getLocalData } from '../../../../services/StorageServices'
import { downloadDst } from '../../../embroidery/components/EmbroideryPage'
import { PlusOutlined } from '@ant-design/icons'
import SameEmbroideryInfoModal from './SameEmbroideryInfoModal'
import { saveEmbroideryInfo, uploadEmbroideryFile, saveReuseEmbroideryInfo, getReuseEmbroideryInfo } from "../../../../services/api/3dApi"
import _ from 'lodash'
import ModalReusedEmbroideryDesignOrders from '../../../reuse-embroidery-info/components/ModalReusedEmbroideryDesignOrders'
import ThreadColorImage from './ThreadColorImage'
import { isAbsoluteUrl } from './ThreadColorImage'
import qs from "qs"
import {Link} from 'react-router-dom'

const ModalEmbroideryInfo = (props) => {
    const {
        sideActive,
        onActiveSide,
        threadColorNote = '',
        isOpen = false,
        meta = {},
        status = '',
        embroideryAreaInfo = {},
        reloadItems,
        marketplace,
        itemNumber,
        dataType,
        productType,
        onStatusItem,
        batchItemId,
        onCancel,
        display = '',
        idItem,
        items = [],
        selectItems = [],
        setSelectItems,
        allIds = [],
        noteOrder,
        orderId,
    } = props

    const barcodeItem = `${marketplace}_${itemNumber}`
    const role = parseJwt(getLocalData('accessToken')).roles
    const { embroidery_sides = [] } = meta

    const [loading, setLoading] = useState(false)
    const [isUploaded, setIsUploaded] = useState(false)
    const [fileChanged, setFileChanged] = useState(false)
    const [previewOpen, setPreviewOpen] = useState(false)
    const [isUploadedColorfile, setIsUploadedColorfile] = useState(false)
    const [colorFileChanged, setColorFileChanged] = useState(false)
    const [showSameEmbroideryInfoModal, setShowSameEmbroideryInfoModal] = useState(false)
    const [error, setError] = useState('')
    const [embroideryPositions, setEmbroideryPositions] = useState([])
    const [firstNamePosition, setFirstNamePosition] = useState('')
    const [firstEmbroideryPosition, setFirstEmbroideryPosition] = useState({
        type: "simple",
        name: "",
        stitch_quantity: 0
    })
    const [embroideryInfo, setEmbroideryInfo] = useState([])
    const [embroideryFiles, setEmbroideryFiles] = useState({})
    const [errorEmbroideryPosition, setErrorEmbroideryPosition] = useState('')
    const [listFile, setListFile] = useState({})
    const [listColorFile, setListColorFile] = useState({})
    const [colorFiles, setColorFiles] = useState({})
    const [listColor, setListColor] = useState({})
    const [colorsError, setColorsError] = useState({})
    // const [capturedEmbroideryDesign, setCapturedEmbroideryDesign] = useState({})
    const [previewColorImage, setPreviewColorImage] = useState('')
    const [ordersErr, setOrderErr] = useState({})
    const [isItemReuse, setIsItemReuse] = useState(false)

    const embroiderySide = !!embroideryPositions.length ? countEmbroideryLocations(embroideryPositions, firstNamePosition, firstEmbroideryPosition) : {}
    const { blink_sidebow, normal_sidebow, re_blink_embroidery_location, re_normal_embroidery_location } = Object.assign({}, embroiderySide)
    const isAllowConfirmSideBow = blink_sidebow > 0 || normal_sidebow > 0
    const isAllowSubmit = Array.isArray(embroideryInfo) && embroideryInfo.length > 0
    const isSupperAdmin = role.length > 0 && role.some(item => ['Super Admin', 'fac_admin'].includes(item.name))
    const isAllowEmbroidery = isSupperAdmin || ["pending"].includes(status)
    const isFirstEmbroideryPosition = !!firstEmbroideryPosition && (!!firstEmbroideryPosition.name || !!firstEmbroideryPosition.stitch_quantity)
    const isReuse = !!embroideryAreaInfo && embroideryAreaInfo.hasOwnProperty('reuse_from')
    const itemOriginEmbroidery = isItemReuse ? barcodeItem : isReuse ? _.get(embroideryAreaInfo, 'reuse_from.org_barcode_item') : null
    const isNotOriginItemAndReuseItem = !isItemReuse && !_.get(embroideryAreaInfo, 'reuse_from.org_barcode_item') && status !== "pending"

    useEffect(() => {
        if (!isOpen) return

        const { embroidery_info = {} } = dataType[productType] || {}
        const { embroidery_position = {} } = { ...embroidery_info }

        if (embroideryAreaInfo && Object.keys(embroideryAreaInfo).length > 0) {
            const hasEmbroideryProps = Object.keys(embroideryAreaInfo).some(i =>
                ['embroidery_positions', 'first_embroidery_position', 'embroidery_files', 'embroidery_colors', 'color_files'].includes(i)
            )

            if (hasEmbroideryProps) {
                const {
                    first_embroidery_position = {},
                    embroidery_files = {},
                    embroidery_colors = {},
                    color_files = {},
                } = { ...embroideryAreaInfo }

                const sortedEmbroiderySides = [...embroidery_sides].sort((a, b) => {
                    const { order: priorityA } = !!embroidery_position[a] ? embroidery_position[a] : {}
                    const { order: priorityB } = !!embroidery_position[b] ? embroidery_position[b] : {}
                    return priorityA - priorityB
                }) || []

                const newFistEmbroidery = sortedEmbroiderySides[0]
                const isExistEmbroidery =
                    _.get(first_embroidery_position, 'name') === newFistEmbroidery

                const newFirstEmbroideryPosition = {
                    ...first_embroidery_position,
                    name: sortedEmbroiderySides[0],
                    stitch_quantity: 0,
                    type: _detectTypeByStitchQuantity(first_embroidery_position.stitch_quantity),
                }

                const isReuse = embroideryAreaInfo.hasOwnProperty('reuse_from')

                const listFileFromServer = createFileListFromServer(embroidery_files, isReuse, barcodeItem)

                const newListImage = createImageListFromServer(color_files)

                const listColorData =
                    (embroidery_colors &&
                        !Array.isArray(embroidery_colors) &&
                        Object.keys(embroidery_colors).length > 0)
                        ? embroidery_colors
                        : buildEmptyListColor(embroidery_sides, sideActive, status)

                setFirstEmbroideryPosition(
                    isExistEmbroidery
                        ? {
                            ...first_embroidery_position,
                            type: _detectTypeByStitchQuantity(first_embroidery_position.stitch_quantity),
                        }
                        : newFirstEmbroideryPosition
                )
                setEmbroideryPositions(embroidery_sides)
                setListFile(listFileFromServer)
                setListColor(listColorData)
                setEmbroideryFiles(embroidery_files)
                setIsUploaded(!!(embroidery_files && Object.keys(embroidery_files).length))
                setListColorFile(newListImage)
                setColorFiles(color_files)
                setIsUploadedColorfile(!!(color_files && Object.keys(color_files).length))

            } else {
                const embroideryAreaInfos = embroidery_sides.reduce((acc, curr) => {
                    if (!Object.keys(embroideryAreaInfos).includes(curr)) {
                        acc[curr] = {
                            type: 'simple',
                            embroidery_stitch_quantity: 0
                        }
                    } else {
                        const item = embroideryAreaInfos[curr] || {}
                        acc[curr] = {
                            type: item.type || 'simple',
                            embroidery_stitch_quantity: item.embroidery_stitch_quantity || 0
                        }
                    }
                    return acc
                }, {})

                const listEmbroideryInfos = Object.entries(embroideryAreaInfos).map(([key, value]) => ({
                    [key]: value
                }))

                setEmbroideryInfo(listEmbroideryInfos)
                setListColor(buildEmptyListColor(embroidery_sides, sideActive, status))
            }

        } else {
            resetEmbroideryState()
            fetchGetFirstEmbroideryPosition()
        }

    }, [isOpen, dataType])

    useEffect(() => {
        if (isOpen && display === 'batch-detail') {
            _fetchDataItemReuse()
        }
    }, [display, isOpen])

    const fetchGetFirstEmbroideryPosition = async () => {
        try {
            const { embroidery_sides = [] } = Object.assign({}, meta)

            const { embroidery_info } = dataType[productType] || {}

            if (!embroidery_info) return

            const { embroidery_position = {} } = Object.assign({}, embroidery_info)

            const listEmbroiderySeted = (embroidery_sides || []).map(side => {
                if (embroidery_position && embroidery_position[side] && typeof embroidery_position[side].order === 'number') {
                    return {
                        side,
                        order: embroidery_position[side].order
                    }
                }
                return null
            }).filter(Boolean)

            let firstEmb = ''
            if (listEmbroiderySeted.length > 0) {
                const min = listEmbroiderySeted.reduce((minItem, currentItem) => currentItem.order < minItem.order ? currentItem : minItem, listEmbroiderySeted[0])
                firstEmb = min && min.side ? min.side : ''
            }

            const listColor = buildEmptyListColor(embroidery_sides, sideActive, status)

            setFirstNamePosition(firstEmb)
            setErrorEmbroideryPosition(firstEmb ? '' : 'Không tìm thấy mặt thêu.')
            setEmbroideryPositions(embroidery_sides)
            setListColor(listColor)
        } catch (error) {
            message.error(error.message)
        }
    }

    const _fetchDataItemReuse = async () => {
        if (!barcodeItem) return

        setLoading(true)
        try {
            const payload = {
                query: {
                    origin_barcode: barcodeItem
                },
            }

            const { data: res } = await getReuseEmbroideryInfo(qs.stringify(payload))
            const { data, success, message: mess } = res
            if (!success) throw new Error(mess)

            const { rows = [] } = { ...data }
            if (!!rows.length) setIsItemReuse(true)

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _hideModal = () => {
        const { embroidery_sides = [] } = meta
        const { first_embroidery_position, embroidery_files = {}, embroidery_colors = {}, color_files = {} } = Object.assign({}, embroideryAreaInfo)
        const isReuse = !!embroideryAreaInfo && embroideryAreaInfo.hasOwnProperty('reuse_from')

        const listFile = createFileListFromServer(embroidery_files, isReuse, barcodeItem)
        const listColor = !!embroidery_colors && !Array.isArray(embroidery_colors) && !!Object.keys(embroidery_colors).length ? embroidery_colors : buildEmptyListColor(embroidery_sides, sideActive, status)
        const listColorFile = createImageListFromServer(color_files)

        setError('')
        setFirstEmbroideryPosition(!!firstNamePosition ?
            {
                type: "simple",
                name: "",
                stitch_quantity: 0
            } : first_embroidery_position)
        setListFile(listFile)
        setListColor(listColor)
        setListColorFile(listColorFile)
        setEmbroideryFiles(embroidery_files)
        setColorsError({})
        setIsUploaded(!!(embroidery_files && Object.keys(embroidery_files).length))
        setFileChanged(false)
        setColorFiles(color_files)
        setIsUploadedColorfile(!!(color_files && Object.keys(color_files).length))
        setColorFileChanged(false)
        onActiveSide([])
        setOrderErr({})
        onCancel()
    }

    const validateColors = () => {
        // Khởi tạo object lỗi rỗng cho từng side
        const colorsError = Object.keys(listColor).reduce((acc, side) => {
            acc[side] = []
            return acc
        }, {})

        let hasError = false

        // Duyệt từng side
        Object.entries(listColor).forEach(([side, colors]) => {
            if (!Array.isArray(colors)) return

            // 1) check rỗng
            colors.forEach((color, idx) => {
                if (!color) {
                    colorsError[side].push({
                        index: idx,
                        message: 'Vui lòng nhập màu thêu.'
                    })
                    hasError = true
                }
            })
        })
        const SidesHaveErr = Object.entries(colorsError)
            .filter(([side, arr]) => Array.isArray(arr) && arr.length > 0)
            .map(([side]) => side)

        setColorsError(colorsError)
        onActiveSide(SidesHaveErr && SidesHaveErr.length ? SidesHaveErr : sideActive,)
        return !hasError
    }

    const resetEmbroideryState = () => {
        const { embroidery_sides = [] } = meta || {}
        setError('')
        setErrorEmbroideryPosition('')
        setFirstEmbroideryPosition({ type: "simple", name: "", stitch_quantity: 0 })
        setEmbroideryInfo([])
        // xóa danh sách file DST hiện tại
        setListFile([])
        setEmbroideryFiles({})
        setIsUploaded(false)
        setFileChanged(false)
        // reset màu theo side mặc định
        setListColor(buildEmptyListColor(embroidery_sides, sideActive))
        // xóa danh sách image color
        setListColorFile([])
        setColorFiles({})
        setIsUploadedColorfile(false)
        setColorFileChanged(false)
        // Reset side
        setEmbroideryPositions(embroidery_sides)
    }

    const UploadFile = async (files, field) => {
        const prefixMap = {
            embroidery_files: 'files',
            color_files: 'color',
        }
        const prefix = prefixMap[field] || ''
        const hasAnyFile = Object.values(files).some(
            arr => Array.isArray(arr) && arr.length > 0
        )
        if (!files || !hasAnyFile) {
            if (field === 'embroidery_files') message.error('Vui lòng chọn file .dst để upload!')
            if (field === 'color_files') message.error('Vui lòng chọn ảnh để upload!')
            return false
        }
        try {
            // Build FormData và upload
            const formData = new FormData()
            Object.entries(files).forEach(([side, arr]) => {
                if (!Array.isArray(arr)) return
                arr.forEach(fileObj => {
                    const file = fileObj.originFileObj || fileObj
                    if (file.url) {
                        // file đã có URL → append string
                        formData.append(`${prefix}.${side}`, file.url)
                    } else {
                        formData.append(`${prefix}.${side}`, file)
                    }
                })
            })

            const { data: res } = await uploadEmbroideryFile(batchItemId, formData)
            const { success, data, error, message: mess } = { ...res }
            if (!success) throw new Error(error || mess)
            let uploadedObj = {}
            if (data) {
                if (data.embroidery_area_info && data.embroidery_area_info[field]) {
                    uploadedObj = data.embroidery_area_info[field]
                } else if (data[field]) {
                    uploadedObj = data[field]
                } else if (data.embroidery_area_info && (data.embroidery_area_info.embroidery_files || data.embroidery_area_info.color_files)) {
                    uploadedObj = data.embroidery_area_info
                }
            }
            message.success(`Upload ${field === 'embroidery_files' ? 'file thêu' : ''} thành công!`)
            return { success: true, uploaded: uploadedObj, data }
        } catch (error) {
            const { data: errData = {} } = error.response || {}
            message.error(errData.message || error.message)
            return false
        }
    }

    const mergeUploadedFiles = (prevFiles = {}, uploadedResponse = {}) => {
        const merged = { ...prevFiles }

        Object.entries(uploadedResponse || {}).forEach(([side, arr]) => {
            const prevSideArr = Array.isArray(prevFiles[side]) ? [...prevFiles[side]] : []
            const toAdd = (Array.isArray(arr) ? arr : []).filter(item =>
                !prevSideArr.some(f =>
                    (f.url && item.url && f.url === item.url) ||
                    (f.file_name && item.file_name && f.file_name === item.file_name)
                )
            )
            merged[side] = [...prevSideArr, ...toAdd]
        })

        return merged
    }

    const _handleSaveInfoEmbroidery = async () => {
        setLoading(true)

        try {
            const isValidColors = validateColors()
            if (!isValidColors) return

            // build base payload
            const newFirstEmbroideryPosition = {
                ...firstEmbroideryPosition,
                type: _detectTypeByStitchQuantity(firstEmbroideryPosition.stitch_quantity)
            }
            const embroiderySide = (Array.isArray(embroideryPositions) && embroideryPositions.length) ? countEmbroideryLocations(embroideryPositions, firstNamePosition, firstEmbroideryPosition) : {}
            const payload = {
                embroidery_positions: embroideryPositions,
                first_embroidery_position: newFirstEmbroideryPosition,
                ...embroiderySide
            }
            if (firstNamePosition) {
                payload.first_embroidery_position = {
                    ...newFirstEmbroideryPosition,
                    name: firstNamePosition,
                    is_blink: !!firstNamePosition && firstNamePosition.toLocaleLowerCase().includes('_blink')
                }
            } else {
                const { name } = Object.assign({}, newFirstEmbroideryPosition)
                payload.first_embroidery_position = {
                    ...newFirstEmbroideryPosition,
                    is_blink: !!name && name.toLocaleLowerCase().includes('_blink')
                }
            }
            if (!!listColor && !!Object.keys(listColor).length && !Array.isArray(listColor)) {
                const cleanedListColor = Object.fromEntries(
                    Object.entries(listColor)
                        .filter(([key, arr]) => embroideryPositions.includes(key) && Array.isArray(arr) && arr.length > 0)
                )
                payload.embroidery_colors = cleanedListColor
            }

            // --- giữ những file đã có url (user giữ lại trên UI) ---
            const listFileOld = Object.fromEntries(
                Object.entries(listFile).map(([key, arr]) => [
                    key,
                    arr.filter(item => item.url).map(item => ({
                        file_name: item.name || item.file_name || '',
                        url: item.url
                    }))
                ])
            ) || {}

            const listColorFileOld = Object.fromEntries(
                Object.entries(listColorFile).map(([key, arr]) => [
                    key,
                    arr.filter(item => item.url).map(item => ({
                        file_name: item.name || item.file_name || '',
                        url: item.url
                    }))
                ])
            ) || {}

            if (!!Object.keys(listFileOld).length) payload.embroidery_files = listFileOld
            if (!!Object.keys(listColorFileOld).length) payload.color_files = listColorFileOld

            // --- Lấy ra file mới (chưa có url) để gửi kèm FormData ---
            const listFilesUpload = Object.fromEntries(
                Object.entries(listFile || {})
                    .map(([side, arr]) => [
                        side,
                        Array.isArray(arr)
                            ? arr.filter(f => !f.url)
                            : []
                    ])
                    .filter(([_, newFiles]) => newFiles.length > 0)
            )

            const listColorFilesUpload = Object.fromEntries(
                Object.entries(listColorFile || {})
                    .map(([side, arr]) => [
                        side,
                        Array.isArray(arr)
                            ? arr.filter(f => f.originFileObj && !f.url)
                            : []
                    ])
                    .filter(([_, newFiles]) => newFiles.length > 0)
            )

            // convertToPayloadColor đã có trong file (trả về { side: [File, File...] })
            if (!!Object.keys(listFilesUpload).length) {
                payload.files = convertToPayloadColor(listFilesUpload)
            }

            if (!!Object.keys(listColorFilesUpload).length) {
                payload.color = convertToPayloadColor(listColorFilesUpload)
            }

            // --- Convert toàn bộ payload -> FormData ---
            const formData = convertToFormData(payload)

            const { data: res } = await saveEmbroideryInfo(batchItemId, formData)
            const { success, error, data } = res || {}
            if (!success) {
                const embroideryAreaInfoFromProps = props.embroidery_area_info || {}
                const isReuseFromProps = !!embroideryAreaInfoFromProps && embroideryAreaInfoFromProps.hasOwnProperty('reuse_from')
                const barcodeItemFromProps = `${marketplace}_${itemNumber}`
                if (data && (data.embroidery_area_info || data.color_files || data.embroidery_files)) {
                    const returnedInfo = data.embroidery_area_info || {}
                    const newlistFileAfterUploaded = createFileListFromServer(returnedInfo.embroidery_files || embroideryAreaInfoFromProps.embroidery_files, isReuseFromProps, barcodeItemFromProps)
                    const newlistImageAfterUploaded = createImageListFromServer(returnedInfo.color_files || embroideryAreaInfoFromProps.color_files)

                    setListFile(newlistFileAfterUploaded)
                    setListColorFile(newlistImageAfterUploaded)
                }

                throw new Error(error || 'Lỗi khi lưu thông tin vùng thêu!')
            }

            const { embroidery_area_info = {} } = Object.assign({}, data)
            const { first_embroidery_position, embroidery_files: new_embroidery_files = {}, color_files: newColorFiles = {} } = Object.assign({}, embroidery_area_info)

            setError('')
            setFirstNamePosition('')
            setFirstEmbroideryPosition(first_embroidery_position)
            setEmbroideryFiles(new_embroidery_files)
            setColorFiles(newColorFiles)
            if (status === "pending" && typeof onStatusItem === "function") await onStatusItem()
            message.success("Lưu thông tin vùng thêu thành công!")
            if ((status === "pending" && !threadColorNote) || (!isItemReuse && !_.get(data, 'embroidery_area_info.reuse_from.org_barcode_item') && status !== "pending")) {
                // setCapturedEmbroideryDesign(capturedEmbroideryDesign)
                reloadItems()
                _handleShowSameEmbroideryInfoModal()
                return
            }

            reloadItems()
            _hideModal()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _handleSaveInfoEmbroidery2 = async () => {
        setLoading(true)
        try {
            const isValidColors = validateColors()
            if (!isValidColors) return

            const newFirstEmbroideryPosition = {
                ...firstEmbroideryPosition,
                type: _detectTypeByStitchQuantity(firstEmbroideryPosition.stitch_quantity)
            }
            const embroiderySide = (Array.isArray(embroideryPositions) && embroideryPositions.length) ? countEmbroideryLocations(embroideryPositions, firstNamePosition, firstEmbroideryPosition) : {}
            const payload = {
                embroidery_positions: embroideryPositions,
                first_embroidery_position: newFirstEmbroideryPosition,
                ...embroiderySide
            }
            if (firstNamePosition) {
                payload.first_embroidery_position = {
                    ...newFirstEmbroideryPosition,
                    name: firstNamePosition,
                    is_blink: !!firstNamePosition && firstNamePosition.toLocaleLowerCase().includes('_blink')
                }
            } else {
                const { name } = Object.assign({}, newFirstEmbroideryPosition)
                payload.first_embroidery_position = {
                    ...newFirstEmbroideryPosition,
                    is_blink: !!name && name.toLocaleLowerCase().includes('_blink')
                }
            }
            if (!!listColor && !!Object.keys(listColor).length && !Array.isArray(listColor)) {
                const cleanedListColor = Object.fromEntries(
                    Object.entries(listColor)
                        .filter(([key, arr]) => embroideryPositions.includes(key) && Array.isArray(arr) && arr.length > 0)
                )
                payload.embroidery_colors = cleanedListColor
            }

            const listFileOld = Object.fromEntries(
                Object.entries(listFile).map(([key, arr]) => [
                    key,
                    arr.filter(item => item.url).map(item => ({
                        file_name: item.name || item.file_name || '',
                        url: item.url
                    }))
                ])
            ) || {}

            const listColorFileOld = Object.fromEntries(
                Object.entries(listColorFile).map(([key, arr]) => [
                    key,
                    arr.filter(item => item.url).map(item => ({
                        file_name: item.name || item.file_name || '',
                        url: item.url
                    }))
                ])
            ) || {}

            if (!!Object.keys(listFileOld).length) payload.embroidery_files = listFileOld
            if (!!Object.keys(listColorFileOld).length) payload.color_files = listColorFileOld

            // --- Danh sách files cần upload (chỉ files chưa có url) và đếm số file new per side ---
            const listFilesUpload = Object.fromEntries(
                Object.entries(listFile || {})
                    .map(([side, arr]) => [
                        side,
                        Array.isArray(arr)
                            ? arr.filter(f => !f.url)
                            : []
                    ])
                    .filter(([_, newFiles]) => newFiles.length > 0)
            )

            const listColorFilesUpload = Object.fromEntries(
                Object.entries(listColorFile || {})
                    .map(([side, arr]) => [
                        side,
                        Array.isArray(arr)
                            ? arr.filter(f => f.originFileObj && !f.url)
                            : []
                    ])
                    .filter(([_, newFiles]) => newFiles.length > 0)
            )

            if (!!Object.keys(listFilesUpload).length) {
                payload.files = convertToPayloadColor(listFilesUpload)
            }

            if (!!Object.keys(listColorFilesUpload).length) {
                payload.color = convertToPayloadColor(listColorFilesUpload)
            }

            if (!!selectItems.length) payload.apply_embroidery_design_orders = selectItems

            const { data: res } = await saveReuseEmbroideryInfo(convertToFormData(payload), idItem)
            const { data, success, error } = res || {}

            const { invalid_orders = {} } = data || {}
            if (!!Object.keys(invalid_orders).length) {
                return setOrderErr(invalid_orders)
            }

            if (!success) throw new Error(error || 'Lỗi khi lưu thông tin vùng thêu!')

            message.success("Lưu thông tin vùng thêu thành công!")
            reloadItems()
            _hideModal()

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const convertToPayloadColor = (input) => {
        const data = {}

        Object.entries(input).forEach(([position, arr]) => {
            const files = arr
                .map(item => item.originFileObj)
                .filter(Boolean)

            if (files.length > 0) {
                data[position] = files
            }
        })

        return data
    }

    const convertToFormData = (payload) => {
        const formData = new FormData()
        const specialGroups = ["color", "files"]

        const appendFormData = (fd, data, parentKey = "") => {
            if (data === null || data === undefined) return

            const parentRoot = parentKey.split(".")[0]
            const isSpecial = specialGroups.includes(parentRoot)

            // Nếu là File
            if (data instanceof File) {
                fd.append(parentKey, data)
                return
            }

            // Nếu là array
            if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    const key = isSpecial ? parentKey : `${parentKey}[${index}]`
                    appendFormData(fd, item, key)
                })
                return
            }

            // Nếu là object
            if (typeof data === "object") {
                Object.keys(data).forEach((key) => {
                    const newKey = parentKey
                        ? isSpecial
                            ? `${parentKey}.${key}`
                            : `${parentKey}[${key}]`
                        : key

                    appendFormData(fd, data[key], newKey)
                })
                return
            }

            // Nếu là primitive
            fd.append(parentKey, data)
        }

        appendFormData(formData, payload)

        return formData
    }

    const _handleChange = (value) => {
        setFirstEmbroideryPosition(preState => ({
            ...preState,
            stitch_quantity: +value
        }))
    }

    const _detectTypeByStitchQuantity = (quantity = 0) => {
        let type = "simple"

        if (quantity >= 25000 && quantity < 50000) type = 'hard'
        if (quantity >= 50000) type = 'very hard'

        return type
    }

    const showUploadTypeFileError = _.once(() => {
        message.error('Chỉ được phép upload file .dst.')
    })

    const showUploadMaxFilesError = _.once(() => {
        message.error('Bạn chỉ được phép tải lên tối đa 5 file.')
    })

    const showUploadMaxImageSizeError = _.once(() => {
        message.error('Ảnh không được vượt quá 5 MB.')
    })

    const showUploadMaxImagesError = _.once(() => {
        message.error('Bạn chỉ được phép tải lên tối đa 5 ảnh.')
    })

    const handleUploadFile = (e, side) => {
        const { file, fileList = [] } = e || {}

        // --- Validate số lượng file tối đa 5 ---
        if (fileList.length > 5) {
            showUploadMaxFilesError()
            return
        }

        setListFile(preState => ({
            ...preState,
            [side]: !!file && !!fileList.length ? fileList : [],
        }))
        setIsUploaded(false)
        setFileChanged(true)

    }

    const _handleBeforeUpload = (file, fileList) => {
        const isDst = file.name.toLowerCase().endsWith('.dst')
        if (!isDst) {
            showUploadTypeFileError()
            return Upload.LIST_IGNORE
        }

        return false
    }

    const _handleRemoveFileUpload = (file, side) => {
        const newListFileSide = Array.isArray(listFile[side]) ? listFile[side].filter(f => f.uid !== file.uid) : []
        const newEmbFilesSide = Array.isArray(embroideryFiles[side]) ? embroideryFiles[side].filter(f => f.url !== file.url) : []

        setListFile(preState => ({
            ...preState,
            [side]: newListFileSide
        }))
        setEmbroideryFiles(preState => ({
            ...preState,
            [side]: newEmbFilesSide
        }))
        setFileChanged(false)
    }

    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })

    const _handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj)
        }

        setPreviewColorImage((file.url || (file.preview)))
        setPreviewOpen(true)
    }

    const _handleBeforeUploadImage = (file) => {
        const isImage = file.type.startsWith('image/')
        if (!isImage) {
            message.error('Chỉ được phép upload file hình ảnh (jpg, png, gif, ...)')
        }
        return isImage ? false : Upload.LIST_IGNORE
    }

    const _handleUploadImage = async (e, side) => {
        const { file, fileList = [] } = e || {}
        const sizeLimit = 5 * 1024 * 1024 // 5 MB
        // 1. Validate kích thước
        if (file.size > sizeLimit) {
            showUploadMaxImageSizeError()
            return
        }

        if (fileList.length > 5) {
            showUploadMaxImagesError()
            return
        }
        // Lọc ra chỉ những file mới có originFileObj (chưa upload lên server)
        const newFiles = fileList
        // Với mỗi file, nếu chưa có preview thì tạo Base64
        const withPreview = await Promise.all(
            newFiles.map(async fileItem => {
                if (!fileItem.preview && fileItem.originFileObj) {
                    // gán preview
                    // lưu tạm để render
                    fileItem.preview = await getBase64(fileItem.originFileObj)
                }
                return fileItem
            })
        )

        // Cập nhật lại listColorFile
        setListColorFile(preState => ({
            ...preState,
            [side]: withPreview,
        }))
        setIsUploadedColorfile(false)
        setColorFileChanged(true)
    }

    const _handleRemoveColorFileUpload = (file, side) => {
        const newListFileSide = Array.isArray(listColorFile[side]) ? listColorFile[side].filter(f => f.uid !== file.uid) : []
        const newEmbFilesSide = Array.isArray(colorFiles[side]) ? colorFiles[side].filter(f => f.url !== file.url) : []

        setListColorFile(preState => ({
            ...preState,
            [side]: newListFileSide
        }))
        setColorFiles(preState => ({
            ...preState,
            [side]: newEmbFilesSide
        }))
        setColorFileChanged(false)
    }

    const _handleChangeColor = (side, index, value) => {
        const sideColors = Array.isArray(listColor[side]) ? [...listColor[side]] : []
        const sideColorsError = Array.isArray(colorsError[side]) ? [...colorsError[side]] : []
        sideColors[index] = value
        const newListColor = {
            ...listColor,
            [side]: sideColors,
        }
        const newColorsError = {
            ...colorsError,
            [side]: !!value ? sideColorsError.filter(i => i.index !== index) : sideColorsError
        }

        setListColor(newListColor)
        setColorsError(newColorsError)
    }

    const _handleDeleteColor = (side, idxDelete) => {
        const sideColors = Array.isArray(listColor[side]) ? [...listColor[side]] : []
        const newSideColors = sideColors.filter((_, idx) => idx !== idxDelete)

        setListColor(preState => ({
            ...preState,
            [side]: newSideColors
        }))
    }

    const _handleAddColor = (side) => {
        const sideColors = Array.isArray(listColor[side]) ? [...listColor[side]] : []
        sideColors.push('')
        setListColor(preState => ({
            ...preState,
            [side]: sideColors
        }))
    }

    const _handleShowSameEmbroideryInfoModal = () => {
        setShowSameEmbroideryInfoModal(true)
    }

    const _handleHideSameEmbroideryInfoModal = () => {
        setShowSameEmbroideryInfoModal(false)
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    return (
        <React.Fragment>
            <Modal
                className='ModalEmbroidery'
                title={
                    <div className='row'>
                        <div className="col-lg-6">
                            Thông tin vị trí thêu
                        </div>
                        <div className="col-lg-6">
                            {
                                !!threadColorNote &&
                                <div className='mb-1' style={{ color: '#ee2b4f' }}>
                                    Màu chỉ yêu cầu: {!!isAbsoluteUrl(threadColorNote) ?
                                        <ThreadColorImage ImageUrl={threadColorNote} /> :
                                        threadColorNote
                                    }
                                </div>
                            }
                            {
                                !!noteOrder && display === 'batch-detail' &&
                                <div className='cursor-pointer' style={{ color: '#007bff' }}>
                                    Note: {
                                        noteOrder.length > 65 ?
                                            <Popover
                                                content={noteOrder}
                                                trigger="hover"
                                                placement='bottom'
                                                overlayClassName="event-key-popover"
                                            >
                                                {`${noteOrder.substring(0, 65)}...`}
                                            </Popover> : noteOrder
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
                visible={isOpen}
                confirmLoading={loading}
                onCancel={_hideModal}
                footer={[
                    <Button key="cancel" onClick={_hideModal}>
                        Cancel
                    </Button>,
                    <Button
                        key="ok"
                        type="primary"
                        onClick={display === 'batch-detail' ? _handleSaveInfoEmbroidery : _handleSaveInfoEmbroidery2}
                        disabled={loading || (isAllowConfirmSideBow ? false : (isAllowSubmit || !!errorEmbroideryPosition)) || isItemReuse}
                    >
                        OK
                    </Button>,
                ]}
            >
                <Spin spinning={loading} tip='Loading...'>
                    <div className="modalContent row d-flex flex-wrap align-items-start justify-content-between">
                        <div className="contentLeft col-lg-6 col-md-12 col-sm-12">
                            {
                                isAllowSubmit ?
                                    embroidery_sides.map((sideItem, i) => {
                                        const item = embroideryInfo.find(i => i[sideItem]) || {}
                                        const { embroidery_stitch_quantity = 0, type: typeEmbroidery = 'simple' } = item[sideItem] || {}
                                        return (
                                            <div key={`${i}_side`} className={`d-flex flex-wrap align-items-center justify-content-between ${i === embroidery_sides.length - 1 ? '' : 'border-bottom'} pb-2 ${i === 0 ? '' : 'pt-2'}`}>
                                                <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                    <span style={{ textTransform: 'capitalize' }}>{sideItem}</span>
                                                </div>
                                                <div className="type">
                                                    <label htmlFor="" style={{ fontWeight: 'bold' }}>Loại</label>
                                                    <Select
                                                        value={typeEmbroidery || []}
                                                        placeholder="Chọn loại"
                                                        disabled
                                                        style={{
                                                            width: 120,
                                                        }}
                                                        onChange={_handleChange}
                                                        className='ml-2'
                                                    >
                                                        <Select.Option value={'simple'}>Đơn giản</Select.Option>
                                                        <Select.Option value={'hard'}>Phức tạp</Select.Option>
                                                        <Select.Option value={'very hard'}>Rất phức tạp</Select.Option>
                                                    </Select>
                                                </div>
                                                <div className="quantity">
                                                    <label htmlFor="" style={{ fontWeight: 'bold' }}>Số mũi thêu</label>
                                                    <InputNumber
                                                        value={embroidery_stitch_quantity || 0}
                                                        onChange={_handleChange}
                                                        disabled
                                                        className='ml-2'
                                                        style={{
                                                            width: 120,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }) :
                                    <>
                                        <div className={`d-flex flex-wrap align-items-center justify-content-between border-bottom pb-3`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <span style={{ textTransform: 'capitalize' }}>Tổng Số Vị Trí</span>
                                            </div>
                                            <div className='inputTotalPositions'>
                                                <InputNumber
                                                    value={!!embroidery_sides ? embroidery_sides.length : 0}
                                                    className='ml-0'
                                                    disabled
                                                    style={{
                                                        width: 120,
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className={`d-flex flex-wrap align-items-center justify-content-between border-bottom pb-3 pt-2`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <div style={{ textTransform: 'capitalize' }}>Mặt Thêu Đầu Tiên</div>
                                                {(isFirstEmbroideryPosition || !!firstNamePosition) && <span className='text-danger font-weight-bold' style={{ textTransform: 'capitalize' }}>{firstEmbroideryPosition.name || firstNamePosition}</span>}
                                            </div>
                                            <div className="quantity">
                                                <div style={{ fontWeight: 'bold' }}>Số mũi thêu</div>
                                                <InputNumber
                                                    value={isFirstEmbroideryPosition ? firstEmbroideryPosition.stitch_quantity : 0}
                                                    onChange={_handleChange}
                                                    disabled={!isAllowEmbroidery || !!errorEmbroideryPosition || isItemReuse}
                                                    className='mt-1'
                                                    style={{
                                                        width: 120,
                                                    }}
                                                />
                                            </div>
                                            <div className="type">
                                                <div style={{ fontWeight: 'bold' }}>Loại</div>
                                                <Select
                                                    value={isFirstEmbroideryPosition ? _detectTypeByStitchQuantity(firstEmbroideryPosition.stitch_quantity) : 'simple'}
                                                    placeholder="Chọn loại"
                                                    disabled
                                                    className='mt-1'
                                                    style={{
                                                        width: 120,
                                                    }}
                                                >
                                                    <Select.Option value={'simple'}>Đơn giản</Select.Option>
                                                    <Select.Option value={'hard'}>Phức tạp</Select.Option>
                                                    <Select.Option value={'very hard'}>Rất phức tạp</Select.Option>
                                                </Select>
                                            </div>
                                        </div>

                                        <div className={`d-flex flex-wrap align-items-center justify-content-between pb-2 pt-3`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <span style={{ textTransform: 'capitalize' }}>Vị Trí Còn Lại (Thường)</span>
                                            </div>
                                            <div className='inputRemainingPosition'>
                                                <InputNumber
                                                    value={re_normal_embroidery_location}
                                                    style={{
                                                        width: 120,
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className={`d-flex flex-wrap align-items-center justify-content-between pb-2 pt-3`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <span style={{ textTransform: 'capitalize' }}>Vị Trí Còn Lại (Kim Tuyến)</span>
                                            </div>
                                            <div className='inputRemainingPosition'>
                                                <InputNumber
                                                    value={re_blink_embroidery_location}
                                                    style={{
                                                        width: 120,
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className={`d-flex flex-wrap align-items-center justify-content-between pb-2 pt-3`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <span style={{ textTransform: 'capitalize' }}>Vị Trí Sidebow (Thường)</span>
                                            </div>
                                            <div className='inputSidebowPosition'>
                                                <InputNumber
                                                    value={normal_sidebow}
                                                    style={{
                                                        width: 120,
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className={`d-flex flex-wrap align-items-center justify-content-between pb-2 pt-3`}>
                                            <div className="Embroidery-area-title font-weight-bold mb-1 h6 text-primary" style={{ minWidth: 80 }}>
                                                <span style={{ textTransform: 'capitalize' }}>Vị Trí Sidebow (Kim Tuyến)</span>
                                            </div>
                                            <div className='inputSidebowPosition'>
                                                <InputNumber
                                                    value={blink_sidebow}
                                                    style={{
                                                        width: 120,
                                                    }}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </>
                            }
                            {
                                !!items.length &&
                                <ModalReusedEmbroideryDesignOrders
                                    orderTemplate={barcodeItem}
                                    items={items}
                                    className="mt-2"
                                    selectItems={selectItems}
                                    setSelectItems={setSelectItems}
                                    allIds={allIds}
                                    ordersErr={ordersErr}
                                />
                            }
                        </div>
                        <div className="contentRight col-lg-6 col-md-12 col-sm-12">
                            <Collapse
                                className='w-100'
                                activeKey={!!sideActive.length ? sideActive : (!!embroidery_sides[0] ? [embroidery_sides[0]] : [])}
                                onChange={onActiveSide}
                                expandIconPosition={'right'}
                            >
                                {Array.isArray(embroidery_sides) && embroidery_sides.map((i, idx) => (
                                    <Collapse.Panel
                                        header={<h6 className='w-100 mb-0 text-uppercase' style={{ fontWeight: 600, color: '#fff' }}>{i}</h6>}
                                        key={i}
                                        disabled={loading}
                                    >
                                        <div className={`uploadFile border-bottom pb-3 w-100`}>
                                            <Upload
                                                className={`uploadFileDST d-flex flex-wrap align-items-start justify-content-between w-100 ${listFile.length > 5 ? 'scroll' : ''}`}
                                                multiple={true}
                                                onChange={(e) => handleUploadFile(e, i)}
                                                fileList={listFile[i] || []}
                                                accept=".dst"
                                                beforeUpload={(file, fileList) => _handleBeforeUpload(file, fileList)}
                                                onDownload={(file) => downloadDst(file.url, file.name)}
                                                disabled={loading}
                                                onRemove={(e) => _handleRemoveFileUpload(e, i)}
                                                showUploadList={false}  // <-- ẩn list mặc định
                                            >
                                                <Button
                                                    className='mr-3'
                                                    disabled={loading || isItemReuse}
                                                >
                                                    Choose file
                                                </Button>
                                            </Upload>
                                            {/* Custom file list (render tay) */}
                                            {Array.isArray(listFile[i]) && listFile[i].length > 0 && (
                                                <div className="embroideryFiles mb-4">
                                                    <div className="listFile custom-file-list">
                                                        {listFile[i].map(file => (
                                                            <div key={file.uid} className="custom-file-item d-flex align-items-center">
                                                                <div className="file-left d-flex align-items-center">
                                                                    <Icon type="paper-clip" style={{ marginRight: 8, fontSize: 16 }} />
                                                                    <a
                                                                        href={file.url}
                                                                        className="custom-file-link"
                                                                        onClick={(e) => {
                                                                            if (isReuse) {
                                                                                e.preventDefault()
                                                                                downloadDst(file.url, file.name)
                                                                            }
                                                                        }}
                                                                        title={file.name}
                                                                    >
                                                                        {file.name}
                                                                    </a>
                                                                </div>

                                                                <div className="file-right ml-auto d-flex align-items-center">
                                                                    {/* Download icon */}
                                                                    <a
                                                                        href={file.url}
                                                                        className="download-action"
                                                                        onClick={(e) => {
                                                                            if (isReuse) {
                                                                                e.preventDefault()
                                                                                downloadDst(file.url, file.name)
                                                                            }
                                                                        }}
                                                                        style={{ marginRight: 12, fontSize: 16 }}
                                                                        title="Download"
                                                                    >
                                                                        <Icon type="download" />
                                                                    </a>

                                                                    {/* Remove icon: gọi onRemove của Upload */}
                                                                    {
                                                                        !isItemReuse &&
                                                                        <a
                                                                            href={file.url}
                                                                            className="remove-action"
                                                                            onClick={(e) => {
                                                                                e.preventDefault()
                                                                                _handleRemoveFileUpload(file, i)
                                                                            }}
                                                                            title="Delete"
                                                                        >
                                                                            <Icon type="delete" className='text-danger' style={{ fontSize: 16 }} />
                                                                        </a>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="listColor">
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <h6 className="title mb-0 mt-3 mr-2">Các bước màu thêu:</h6>
                                                <div className="UploadImage mt-3 w-100">
                                                    <Upload
                                                        className=''
                                                        listType="picture-card"
                                                        fileList={listColorFile[i] || []}
                                                        onPreview={_handlePreview}
                                                        beforeUpload={_handleBeforeUploadImage}
                                                        onChange={(e) => _handleUploadImage(e, i)}
                                                        onRemove={(e) => _handleRemoveColorFileUpload(e, i)}
                                                        accept="image/*"
                                                        onDownload={true}
                                                        disabled={loading || isItemReuse}
                                                        multiple
                                                        showUploadList={
                                                            {
                                                                showDownloadIcon: true,
                                                                downloadIcon: 'Download',
                                                                showRemoveIcon: !isItemReuse,
                                                                removeIcon: 'Delete',
                                                            }
                                                        }
                                                        style={{ width: 120, height: 120 }}
                                                    >
                                                        {(!Array.isArray(listColorFile[i]) || !listColorFile[i].length || listColorFile[i].length < 5) && uploadButton}
                                                    </Upload>
                                                </div>
                                            </div>
                                            <div className="list d-flex flex-wrap mb-3" style={{ maxHeight: 144, overflow: 'auto' }}>
                                                <div className="list1 d-flex flex-column mr-auto">
                                                    {!!listColor[i] && listColor[i].length > 0 && listColor[i].map((color, colorIdx) => (
                                                        colorIdx < (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                        <div key={`colorItem_${i}_${colorIdx + 1}`} className="colorItem w-100 d-flex flex-column align-items-center justify-content-start mb-3">
                                                            <div className="inputContent w-100 d-flex align-items-center justify-content-start">
                                                                <span className="index mx-2" style={{ minWidth: 47 }}>Màu {colorIdx + 1}</span>
                                                                <Input
                                                                    className={`mx-2 ${Array.isArray(colorsError[i]) && colorsError[i].some(err => err.index === colorIdx) ? 'inputError' : ''}`}
                                                                    value={color || ''}
                                                                    style={{ width: 120 }}
                                                                    placeholder='Mã màu'
                                                                    onChange={e => _handleChangeColor(i, colorIdx, e.target.value)}
                                                                    allowClear
                                                                    disabled={loading || isItemReuse}
                                                                />
                                                                {
                                                                    !isItemReuse &&
                                                                    <div className="deleteAction mx-2">
                                                                        <i
                                                                            className="fa fa-trash cursor-pointer"
                                                                            style={{ fontSize: 20, color: 'red' }}
                                                                            onClick={() => _handleDeleteColor(i, colorIdx)}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                            {Array.isArray(colorsError[i]) && colorsError[i].some(err => err.index === colorIdx) &&
                                                                <div className="inputErrContent d-flex align-items-center justify-content-start w-100">
                                                                    <span className="index mx-2" style={{ minWidth: 47 }}></span>
                                                                    <small className='mx-2 mt-1 text-danger font-weight-bold'>{Array.isArray(colorsError[i]) && colorsError[i].find(err => err.index === colorIdx).message}</small>
                                                                </div>
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="list2 d-flex flex-column">
                                                    {!!listColor[i] && listColor[i].length > 0 && listColor[i].map((color, colorIdx) => (
                                                        colorIdx >= (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                        <div key={`colorItem_${i}_${colorIdx + 1}`} className="colorItem w-100 d-flex flex-column align-items-center justify-content-start mb-3">
                                                            <div className="inputContent w-100 d-flex align-items-center justify-content-start">
                                                                <span className="index mx-2" style={{ minWidth: 47 }}>Màu {colorIdx + 1}</span>
                                                                <Input
                                                                    className={`mx-2 ${Array.isArray(colorsError[i]) && colorsError[i].some(err => err.index === colorIdx) ? 'inputError' : ''}`}
                                                                    value={color || ''}
                                                                    style={{ width: 120 }}
                                                                    placeholder='Mã màu'
                                                                    onChange={e => _handleChangeColor(i, colorIdx, e.target.value)}
                                                                    allowClear
                                                                    disabled={loading || isItemReuse}
                                                                />
                                                                {
                                                                    !isItemReuse &&
                                                                    <div className="deleteAction mx-2">
                                                                        <i
                                                                            className="fa fa-trash cursor-pointer"
                                                                            style={{ fontSize: 20, color: 'red' }}
                                                                            onClick={() => _handleDeleteColor(i, colorIdx)}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                            {Array.isArray(colorsError[i]) && colorsError[i].some(err => err.index === colorIdx) &&
                                                                <div className="inputErrContent d-flex align-items-center justify-content-start w-100">
                                                                    <span className="index mx-2" style={{ minWidth: 47 }}></span>
                                                                    <small className='mx-2 mt-1 text-danger font-weight-bold'>{Array.isArray(colorsError[i]) && colorsError[i].find(err => err.index === colorIdx).message}</small>
                                                                </div>
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <Button disabled={loading || (Array.isArray(listColor[i]) && listColor[i].length >= 30) || isItemReuse} onClick={() => _handleAddColor(i)}>Thêm màu</Button>
                                        </div>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                            <Modal
                                visible={previewOpen}
                                title={'Preview image'}
                                footer={null}
                                onCancel={() => setPreviewOpen(false)}
                            >
                                <img
                                    alt="preview"
                                    style={{ width: '100%' }}
                                    src={previewColorImage}
                                />
                            </Modal>
                        </div>
                    </div>
                    {
                        !isAllowEmbroidery &&
                        <span className='text-danger mt-2 d-inline-block'>
                            Chỉ cho phép nhập thông tin thêu khi user là admin hoặc item ở trạng thái <span className='font-weight-bold'>"pending"</span> !
                        </span>}
                    {!!errorEmbroideryPosition && <din className='text-danger font-weight-bold mt-2'>{errorEmbroideryPosition}</din>}
                    {!!error && <span className='text-danger font-weight-bold mt-2'>{error}</span>}
                    {
                        display === "batch-detail" && (isItemReuse || isReuse) &&
                        <div className='mt-2 text-danger font-weight-bold'>
                            Đơn có áp dụng thiết kế gốc.<br />
                            Truy cập <Link to={`/reuse-embroidery-info?barcode=${itemOriginEmbroidery}`} target="_blank" className='text-primary font-weight-bold'>Thiết kế thêu</Link> để cập nhật toàn bộ item dùng thiết kế.<br />
                            {
                                isReuse && <span>Chỉnh sửa trên popup nếu chỉ cập nhật riêng cho item này</span>
                            }
                        </div>
                    }
                </Spin>
            </Modal>
            {showSameEmbroideryInfoModal &&
                <SameEmbroideryInfoModal
                    showSameEmbroideryInfoModal={showSameEmbroideryInfoModal}
                    handleHideSameEmbroideryInfoModal={_handleHideSameEmbroideryInfoModal}
                    hideModalEmbroidery={_hideModal}
                    marketplace={marketplace}
                    itemNumber={itemNumber}
                    orderId={orderId}
                    setLoading={(value) => setLoading(value)}
                    reloadItems={reloadItems}
                    isNotOriginItemAndReuseItem={isNotOriginItemAndReuseItem}
                />
            }
        </React.Fragment>
    )
}

export default ModalEmbroideryInfo